var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.data),function(item,i){return _c('div',{key:i,staticClass:"tab",class:{active: item.active},on:{"click":function($event){return _vm.$emit('set', item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }